var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import { Box } from "grommet";
import styled from "styled-components";
export var StyledBox = styled(Box)(
  _templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"]))
);
